export default {
  "1": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Вчора"])},
  "2": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Чат"])},
  "3": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Сьогодні"])},
  "4": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Понеділок"])},
  "5": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Вівторок"])},
  "6": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Середа"])},
  "7": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Четвер"])},
  "8": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["П'ятниця"])},
  "9": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Субота"])},
  "10": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Неділя"])},
  "11": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["січня"])},
  "12": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["лютого"])},
  "13": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["березня"])},
  "14": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["квітня"])},
  "15": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["травня"])},
  "16": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["червня"])},
  "17": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["липня"])},
  "18": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["серпня"])},
  "19": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["вересня"])},
  "20": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["жовтня"])},
  "21": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["листопада"])},
  "22": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["грудня"])},
  "23": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Ви"])},
  "24": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Адміністратор"])}
}